export const isSSR = () => navigator.userAgent === 'SSR';
